export default __webpack_public_path__ + "16f66ab.png";